// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__1cVqe","form":"EditListingDescriptionPanel_form__S64kv","title":"EditListingDescriptionPanel_title__2ZqoR"};